
import classNames from 'classnames';
import Markdown from 'markdown-to-jsx';
import * as React from 'react';
import MarkdownAnchor from './MarkdownAnchor';
interface IMarkdownViewProps {
    text: string;
    className?:string
}

const MarkdownView: React.FunctionComponent<IMarkdownViewProps> = (props) => {

    return (<div className={classNames('markdown-view', props.className)}>
        <Markdown options={{
            overrides: {
                a: {
                    component: MarkdownAnchor
                }
            }
        }}>
            {props.text || ''}

        </Markdown>
    </div>);
}

export default MarkdownView